export default __webpack_public_path__ + "static/media/7-NikauSunrise.40074732.jpeg";